






























import { defineComponent } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'

// Components
import SupportHeroSection from '@/components/feature/learn-and-support/technical-support/home/SupportHeroSection.vue'
import SupportLinkTiles from '@/components/feature/learn-and-support/technical-support/home/SupportLinkTiles.vue'
import SupportContactTiles from '@/components/feature/learn-and-support/technical-support/support-tiles/SupportContactTiles.vue'

// Stores
import { usePageStore } from '~/store'
import { useCMSMeta } from '~/composables/cms/useCMSMeta'

export default defineComponent({
  name: 'TechnicalSupport',

  components: {
    SupportHeroSection,
    SupportLinkTiles,
    SupportContactTiles,
  },

  layout: 'fullscreen',

  setup() {
    const { data: template, isLoading } = storeToRefs(usePageStore())

    // Set the meta tags for title and description
    useCMSMeta(template.value?.seoMetadata, {
      title: 'Technical Support',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'CST Technical Support',
        },
      ],
    })

    return {
      template,
      isLoading,
    }
  },

  // Fetch technical support page from Contentstack
  async asyncData(ctx) {
    try {
      await usePageStore(ctx.$pinia).fetchPageByDevKey('technical-support')
    } catch (error: any) {
      const logName = { type: 'ContentStackAxiosError' }
      const newError = { ...error, ...logName }
      ctx.$logService.sendError(newError)

      ctx.error({ statusCode: error.response?.status, message: error.message })
    }
  },

  head: {},
})
